import React from 'react';
import { PageHeader } from '../Common/PageHeader';
import { PagePanel } from '../Common/PageHarness';
import { Button, List, ListItemButton, ListItemText } from '@mui/material';
import { useAdminLegacyResults } from './useAdminLegacyResults';
import { AutoexpanderDefault, Buttons, Dialog, EmptyState, FormGrid, LoadingIndicator, SimpleDialog, useDialogState } from '../../toolympus/components/primitives';
import { FormControlsForFields, TableForFields } from '../../toolympus/components/schemed';
import { Add, DeleteOutlined, Save, Settings, UploadFileOutlined } from '@mui/icons-material';
import { TabButtons } from '../Common/TabButtons';
import { LegacyResultsImportDialog } from './LegacyResultsImportDialog';

interface Props {
  
}

export const AdminLegacyResultsPage = (props: Props) => {
  const data = useAdminLegacyResults();

  const configsDialog = useDialogState();

  return (<>
    <PageHeader
      title="Legacy results"
      // isLoading={data.isLoading}
      actionsStart={<>
      </>}
      
      actions={<>
        <FormControlsForFields
          data={{ year: data.resultsYear.value }}
          schema={data.resultsSchema}
          onChange={(o,c) => data.resultsYear.update(c.year)}
          fields={[
            ["year", { autoComplete: true, wrapperStyle: { width: 100 }}],
          ]}
          />
        <Button color="primary" onClick={() => data.importResults.start() } startIcon={<UploadFileOutlined />}>import</Button>
        <Button color="primary" onClick={() => data.results.newRecord.startEditing() } startIcon={<Add />}>add</Button>
        <Button onClick={() => configsDialog.open() } startIcon={<Settings />}>config</Button>
      </>}
      >

      <TabButtons
        tabs={data.configs.data.map(c => ([c.kind,c.title]))}
        currentTab={data.selectedKind.value}
        selectTab={v => data.selectedKind.update(v)}
        />
    </PageHeader>

    <PagePanel fillPage noTableStyle noPad fixMaxHeight>
      <TableForFields
        data={data.results.data}
        fields={data.resultsFields}
        schema={data.resultsSchema}
        autoexpander={AutoexpanderDefault}
        onRowClick={r => data.results.editRecord.startEditing({ ...r })}
        // fieldElement={fieldElement}
        />
    </PagePanel>

    <Dialog
      dialogTitle="Legacy results configuration"
      {...configsDialog}
      noFullscreen
      titleActions={<>
        {!!data.editConfig.hasChanges && <Button size="small" color="primary" startIcon={<Save />} onClick={() => data.editConfig.save()}>save</Button>}
      </>}>

      <FormGrid columns="1fr 2fr">
        <div>
          <List>
            {data.configs.data.map(c => (
              <ListItemButton key={c.kind}>
                <ListItemText primary={c.title} secondary={c.kind} onClick={() => data.editConfig.startEditing({ ...c })} />
              </ListItemButton>
            ))}
          </List>
          <Button startIcon={<Add />} color="primary" onClick={() => data.newConfig.startEditing()}>add kind</Button>
          {data.configs.isLoading && <LoadingIndicator sizeVariant="s" color="primary" />}
        </div>

        {!!data.editConfig.item &&
          <FormGrid noMargin columns="1fr">
            <FormControlsForFields
              data={data.editConfig.item}
              onChange={(o,c) => data.editConfig.update(c)}
              schema={data.configSchema}
              fields={[
                ["kind"],
                ["title"],
                ["sort_order"],
              ]}
              />

            <FormControlsForFields
              data={data.editConfig.item.labels || {}}
              onChange={(o,c) => data.editConfig.update({ labels: { ...(o || {}), ...c }})}
              schema={data.configLabelsSchema}
              fields={[
                ["holder"],
                ["result1"],
                ["result2"],
                ["result3"],
                ["result4"],
                ["result5"],
              ]}
              />

            <Buttons style={{ justifyContent: "flex-end" }}>
              <Button size="small" startIcon={<DeleteOutlined />} onClick={() => data.editConfig.item && data.removeConfig.run(data.editConfig.item)}>
                delete
              </Button>
            </Buttons>

          </FormGrid>}

          {!data.editConfig.item &&
            <EmptyState text="Select or add results kind to the left" />}
      </FormGrid>
    </Dialog>

    <SimpleDialog
      dialogTitle="New legacy results kind"
      noFullscreen
      submitOnModEnter
      {...data.newConfig.dialog}
      save={() => data.newConfig.save()}>
        {!!data.newConfig.item &&
          <FormGrid noMargin columns="1fr">
            <FormControlsForFields
              data={data.newConfig.item}
              onChange={(o,c) => data.newConfig.update(c)}
              schema={data.configSchema}
              fields={[
                ["kind"],
                ["title"],
                ["sort_order"],
              ]}
              />
          </FormGrid>}
    </SimpleDialog>


    <SimpleDialog
      dialogTitle="Add legacy result"
      noFullscreen
      submitOnModEnter
      {...data.results.newRecord.dialog}
      save={() => data.results.newRecord.save()}>
        {!!data.results.newRecord.item &&
          <FormGrid noMargin columns="1fr">
            <FormControlsForFields
              data={data.results.newRecord.item}
              onChange={(o,c) => data.results.newRecord.update(c)}
              schema={data.resultsSchema}
              fields={[
                ["year", { autoComplete: true }],
                ...data.resultsFields,
              ]}
              />
          </FormGrid>}
    </SimpleDialog>

    <SimpleDialog
      dialogTitle="Edit legacy result"
      noFullscreen
      submitOnModEnter
      simpleExtraActions={<>
        <Button size="small" startIcon={<DeleteOutlined />} onClick={() => data.results.editRecord.item && data.results.remove.run(data.results.editRecord.item)}>
          delete
        </Button>
      </>}
      {...data.results.editRecord.dialog}
      save={() => data.results.editRecord.save()}>
        {!!data.results.editRecord.item &&
          <FormGrid noMargin columns="1fr">
            <FormControlsForFields
              data={data.results.editRecord.item}
              onChange={(o,c) => data.results.editRecord.update(c)}
              schema={data.resultsSchema}
              fields={[
                ["year", { autoComplete: true }],
                ...data.resultsFields,
              ]}
              />
          </FormGrid>}
    </SimpleDialog>



    {!!data.importResults.item &&
      <LegacyResultsImportDialog data={data.importResults} />}
  </>);
}
